// Tag for graphql format
const gql = String.raw;

import { TierCommissionsPaymentFragment } from "@PayPlans/api/fragments/commons";

// Default Commissions fragments
const DefaultAdvisorDefinitionFragment = gql`
	fragment DefaultAdvisorDefinition on DefaultAdvisorDefinition {
		tiers {
			...TierCommissionsPayment
		}
	}
	${TierCommissionsPaymentFragment}
`;

const AdvisorDefaultFragment = gql`
	fragment AdvisorDefault on AdvisorDefault {
		parts {
			...DefaultAdvisorDefinition
		}
		labor {
			...DefaultAdvisorDefinition
		}
		partsAndLabor {
			...DefaultAdvisorDefinition
		}
		isPartsAndLabor
		isGuaranteedDraw
	}
	${DefaultAdvisorDefinitionFragment}
`;

const FollowUpPerformanceBonusFragment = gql`
	fragment FollowUpPerformanceBonus on FollowUpPerformanceBonus {
		tiers {
			from {
				...InputValue
			}
			to {
				...InputValue
			}
			bonuses {
				from {
					...InputValue
				}
				to {
					...InputValue
				}
				bonus {
					...InputValue
				}
			}
		}
	}
`;

const RetentionFragment = gql`
	fragment Retention on AdvisorRetentionPay {
		retention {
			input
			value
		}
		internal {
			input
			value
		}
		warranty {
			input
			value
		}
	}
`;

const HolidayPayFragment = gql`
	fragment HolidayPay on HolidayPayAdvisor {
		_id
		holidaysSelected {
			localHolidayName
			holidayName
			date
		}
		holidayByType
	}
`;

export { AdvisorDefaultFragment, FollowUpPerformanceBonusFragment, RetentionFragment, HolidayPayFragment };
